function E() {
  if (typeof Promise < "u" && Promise.defer)
    return Promise.defer();
  var e = {};
  return e.promise = new Promise(function(r, s) {
    e.resolve = r, e.reject = s;
  }), e;
}
const d = {}, C = {}, T = async (e) => {
  try {
    const r = e.headers.get("content-type");
    if (r && (r.includes("application/json") || r.includes("application/graphql") || r.includes("text/javascript"))) {
      const s = await e.json();
      if (e.url.includes("graphql.json")) {
        const { data: a } = s;
        return { ...a };
      }
      return s;
    }
    return await e.text();
  } catch (r) {
    return console.error("Error in formattedResponse", r), await e.text();
  }
}, q = (e) => {
  const r = new URLSearchParams();
  for (const s in e) {
    const t = e[s];
    if (Array.isArray(t))
      for (const a of t)
        r.append(s, a);
    else
      r.set(s, t);
  }
  return r;
}, j = (e) => {
  const r = {};
  for (const [s, t] of e)
    r[s] ? Array.isArray(r[s]) ? r[s].push(t) : r[s] = [r[s], t] : r[s] = t;
  return r;
}, i = async (e, r, s, t, a) => {
  var o, l, f, p;
  try {
    const n = {
      ...e.headers,
      ...(t == null ? void 0 : t.headers) || {}
    }, m = a != null && a.params ? q(a.params) : null;
    (o = e == null ? void 0 : e.onRequestStart) == null || o.call(e);
    const b = {
      ...n,
      ...(t == null ? void 0 : t.headers) || {}
    };
    a != null && a.removeContentType && delete b["Content-Type"];
    const S = (t == null ? void 0 : t.method) || e.defaultMethod || "GET", y = (a == null ? void 0 : a.withCache) && S === "GET", u = `${e.baseUrl}${s}${m ? "?" + m.toString() : ""}`;
    if (y) {
      const c = r.get(u);
      if (c)
        return c;
    }
    const h = await fetch(u, {
      signal: e.signal,
      method: S,
      ...t,
      headers: b,
      ...(t == null ? void 0 : t.body) && (a == null ? void 0 : a.rawBody) && { body: t.body },
      ...(t == null ? void 0 : t.body) && !(a != null && a.rawBody) && { body: JSON.stringify(t.body) }
    });
    if (!h.ok || h.status >= 400)
      throw await T(h);
    if ((f = (l = t == null ? void 0 : t.headers) == null ? void 0 : l["Content-Type"]) != null && f.includes(
      "text/"
    )) {
      const c = await h.text();
      return y && r.set(u, c), c;
    }
    const A = await T(h);
    return y && r.set(u, A), A;
  } catch (n) {
    if (n !== "Previous request aborted")
      throw console.error("Error in createApiClient", n), n;
    return new Promise(() => {
    });
  } finally {
    (p = e == null ? void 0 : e.onRequestEnd) == null || p.call(e);
  }
}, P = async (e, r, s) => {
  if (C[s])
    return;
  C[s] = !0;
  const t = d[s];
  for (; t.length > 0; ) {
    const { requestArguments: a, deferred: o } = t.shift();
    try {
      const l = await i(
        e,
        r,
        a.endpoint,
        a.init,
        a.options
      );
      o.resolve(l);
    } catch (l) {
      o.reject(l);
    }
  }
  C[s] = !1;
}, w = (e) => {
  const r = new R();
  return e.withQueue && e.queueKey && (d[e.queueKey] || (d[e.queueKey] = [])), (s, t, a) => {
    if (e.withQueue && e.queueKey) {
      const o = E();
      return d[e.queueKey].push({
        requestArguments: { endpoint: s, init: t, options: a },
        deferred: o
      }), P(e, r, e.queueKey), o.promise;
    }
    return i(
      e,
      r,
      s,
      t,
      a
    );
  };
}, x = (e) => {
  class r extends e {
    constructor() {
      super(...arguments), this.$api = new U(this);
    }
  }
  return r;
};
class U {
  constructor(r) {
    this.abortController = new AbortController(), this.fetchClient = w({
      baseUrl: "",
      signal: this.abortController.signal
    }), this.storefrontClient = w({
      baseUrl: `${window.Shopify.routes.root === "/" ? "" : window.Shopify.routes.root}/api/2024-07/graphql.json`,
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": `${window.__STOREFRONT_ACCESS_TOKEN__}`
      },
      defaultMethod: "POST",
      signal: this.abortController.signal
    }), this.shopifyClient = w({
      baseUrl: `${window.Shopify.routes.root}`,
      headers: {
        "Content-Type": "application/json"
      },
      signal: this.abortController.signal
    }), (this.host = r).addController(this);
  }
  hostDisconnected() {
    this.abortController.abort();
  }
  get client() {
    return {
      fetchClient: this.fetchClient,
      storefront: (r) => this.storefrontClient("", r),
      shopify: this.shopifyClient
    };
  }
}
class R {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.get = (r) => this.cache.get(r), this.set = (r, s) => this.cache.set(r, s), this.clear = () => this.cache.clear();
  }
}
export {
  x as W,
  w as c,
  E as d,
  j as f
};
